import * as S from "../styles";
import * as yup from "yup";

import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { LoadingButton } from "@mui/lab";

import CheckBox from "@/components/hookForms/checkbox";
import AutoComplete from "@/components/hookForms/autoComplete";
import IGenericResult from "@/interfaces/IGenericResult";
import messages from "@/utils/messages";
import serviceRelatorio from "@/services/serviceRelatorio";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import serviceUsina from "@/services/serviceUsina";
import DatePickerMui from "@/components/hookForms/datePicker";
import { yupResolver } from "@hookform/resolvers/yup";
import { format } from "date-fns";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function ConsolidacaoCliente({ open, onClose }: IDialogProps) {
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const history = useHistory();

    const validationSchema = yup.object().shape({
        ciclo: yup.string().required(messages.requiredField).typeError(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            concessionariaID: "",
            usinaID: "",
            ciclo: "",
        },
    });

    useEffect(() => {
        setConcessionariaData();
        setUsinaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);
        setLoading(true);

        const newValues = {
            ...values,
            ciclo: format(new Date(values.ciclo), "yyyy-MM"),
            relatorioTipoID: 24,
        };

        serviceRelatorio
            .getRelatorioConsolidacaoCliente(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                setLoading(false);
                if (newValues.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Consolidação de clientes</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(onclose);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <DatePickerMui
                                    id="ciclo"
                                    name="ciclo"
                                    label="Ciclo"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <AutoComplete
                                        id="concessionariaID"
                                        name="concessionariaID"
                                        label="Concessionária"
                                        options={concessionariaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <AutoComplete
                                        id="usinaID"
                                        name="usinaID"
                                        label="Usina"
                                        options={usinaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <CheckBox
                                    name="redirecionar"
                                    label="Redirecionar para a tela de relatório"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose(onClose);
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            loading={isLoading}
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
